import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { ImportacaoComponent } from './importacao.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PoModule,
  ],
  declarations: [ImportacaoComponent],
  exports: [ImportacaoComponent]
})
export class ImportacaoModule { }
